var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"capacity-page-body"},[_c('capacity-component',{on:{"handleQuoteRedirect":_vm.handleQuoteRedirect}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }